import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../services.service';
import {environment} from '../../environments/environment';
import {ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-verify-user',
  templateUrl: './verify-user.component.html',
  styleUrls: ['./verify-user.component.css']
})
export class VerifyUserComponent implements OnInit {
  apiBaseUrl: string        = environment.apiBaseUrl;
  header                    = 'l-header';
  navbar                    = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
  token;
  email;
  isVerify                  =false;
  isFailed                  =false;
  constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.email = params['email'];
    });
    this.verifyAccount(this.token,this.email);
  }

  verifyAccount(token,email) {
    const data = {'token': token,'email':email};
    this._service.verifyAccount(data).subscribe((result: any) => { //console.log(result.result);
      if(result.status ==200){
        this.isVerify = true;
      }else{
        this.isFailed = true;
      }

      // console.log('getCartDetailResults', this.productArray);
    });
  }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/verify-user/verify-user.component.ts